<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
        <p>{{ date }}</p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }}
            {{ address.zipcode }}
        </p>
        <p>
            Attn:  Dispute Manager
        </p>
        <p style="text-align: center;">
            Notice to Agent is Notice to Principal,  Notice to Principal is Notice to Agent 
        </p>
        <p>
            15 U.S. Code § 1681i - Procedure in case of disputed accuracy 
        </p>
        <p class="letter-content">
            (a)Reinvestigations of Disputed Information
        </p>
        <p class="letter-content">
            (1)Reinvestigation Required
        </p>
        <p class="letter-content">
            (A)In general, subject to subsection (f) and except as provided in subsection (g), if the completeness or accuracy of any item of information contained in a consumer’s file at a consumer reporting agency is disputed by the consumer and the consumer notifies the agency directly, or indirectly through a reseller, of such dispute, the agency shall, free of charge, conduct a reasonable reinvestigation to determine whether the disputed information is inaccurate and record the current status of the disputed information, or delete the item from the file in accordance with paragraph (5), before the end of the 30-day period beginning on the date on which the agency receives the notice of the dispute from the consumer or reseller.
        </p>
        <p class="letter-content">
            It has been over 30 days since you received my dispute on <strong>{{ dateAccountRemoved != null ? moment(dateAccountRemoved).format('LL'):'( Date when 1st letter was delivered)' }}</strong> please see Tracking #(Insert your certified mail Tracking number here). 
        </p>
        <p class="letter-content">
            You have not responded to my dispute and the law clearly states that information that has not been verified within 30 days of the dispute must be deleted. You are hereby put on notice that you have violated 15 USC 1681i and the blow account must be deleted immediately.
        </p>
        <p>
            Sincerely, {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
        <div class="page-content">
            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
            <p style="padding-top:3rem; text-align: center;">
                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
            </p>
            <p v-if='userStore.user.address_verify_image_url'>
                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
            </p>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            },
            dateAccountRemoved:{
                type: String
            }
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                _: _,
                moment:moment,
                address,
            };
        },
    };
</script>
